<template>
    <v-card v-bind="props_card">
        <v-card-text :class="{ 'px-12 py-8': detect == 'pc' }">
            <v-row justify="space-between" align="center">
                <v-col cols="12" lg="6">
                    <div class="tit tit--xs">
                        <v-layout
                            v-bind="{
                                'align-center': true,
                                'justify-space-between': detect == 'mobile',
                            }"
                            style="gap:16px"
                        >
                            <span>
                                <b class="primary--text">{{ user?.name }}</b>
                                <span>님 반갑습니다</span>
                            </span>

                            <v-btn x-small color="primary" style="border-radius:8px!important" @click="certificate">
                                <v-layout justify-center align-center style="gap:4px">
                                    <span> 본인인증 등록 </span>
                                    <template>
                                        <v-icon v-if="user?.ci" size="16" color="#5eb86c">mdi-shield-lock-open-outline</v-icon>
                                    </template>
                                </v-layout>
                            </v-btn>
                        </v-layout>
                    </div>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-row class="mx-n3 my-0" justify-md="end">
                        <v-col class="px-3 py-0" cols="12">
                            <v-layout
                                v-bind="{
                                    'align-center': true,
                                    'justify-end': detect == 'pc',
                                    'justify-space-between': detect == 'mobile',
                                }"
                            >
                                <span> 나누리캐시 </span>
                                <v-btn text min-width="auto" class="cash-btn mr-n3" :class="{ 'my-n1': detect == 'pc' }" to="/mypage/cashes/inquiry">
                                    <v-layout justify-end>
                                        <b class="primary--text"> {{ (user?.cash || 0)?.format?.() }} </b>
                                        <span>원</span>
                                    </v-layout>
                                </v-btn>
                            </v-layout>
                        </v-col>
                        <v-col class="px-3 py-0" cols="12" md="auto">
                            <v-layout
                                v-bind="{
                                    'align-center': true,
                                    'justify-end': detect == 'pc',
                                    'justify-space-between': detect == 'mobile',
                                }"
                            >
                                <span> 포인트 </span>
                                <v-btn text min-width="auto" class="cash-btn mr-n3" :class="{ 'my-n1': detect == 'pc' }" to="/mypage/points">
                                    <v-layout justify-end>
                                        <b class="primary--text"> {{ (user?.point || 0)?.format?.() }} </b>
                                        <span>원</span>
                                    </v-layout>
                                </v-btn>
                            </v-layout>
                        </v-col>
                        <v-col class="px-3 py-0" cols="12" md="auto" v-if="user?.hasDeposit">
                            <v-layout
                                v-bind="{
                                    'align-center': true,
                                    'justify-end': detect == 'pc',
                                    'justify-space-between': detect == 'mobile',
                                }"
                            >
                                <span> 보증금 </span>
                                <v-btn text min-width="auto" class="cash-btn mr-n3" :class="{ 'my-n1': detect == 'pc' }" to="/mypage/points">
                                    <v-layout justify-end>
                                        <b class="primary--text"> {{ (user?.deposit || 0)?.format?.() }} </b>
                                        <span>원</span>
                                    </v-layout>
                                </v-btn>
                            </v-layout>
                        </v-col>
                        <v-col class="px-3 py-0" cols="12" md="auto" v-if="user?.hasReserve">
                            <v-layout
                                v-bind="{
                                    'align-center': true,
                                    'justify-end': detect == 'pc',
                                    'justify-space-between': detect == 'mobile',
                                }"
                            >
                                <span> 유보금 </span>
                                <v-btn text min-width="auto" class="cash-btn mr-n3" :class="{ 'my-n1': detect == 'pc' }" to="/mypage/points">
                                    <v-layout justify-end>
                                        <b class="primary--text"> {{ (user?.reserve || 0)?.format?.() }} </b>
                                        <span>원</span>
                                    </v-layout>
                                </v-btn>
                            </v-layout>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <kcp-cert ref="kcpCert" />
        </v-card-text>
    </v-card>
</template>

<script>
import api from "@/api";
import detect from "@/plugins/detect";
import { mapActions, mapState } from "vuex";

import KcpCert from "@/components/plugins/kcp/kcp-cert.vue";

export default {
    components: {
        KcpCert,
    },
    data: () => ({
        detect,
    }),
    computed: {
        ...mapState(["user"]),
        props_card() {
            switch (detect) {
                case "pc": {
                    return {
                        rounded: true,
                    };
                }
                case "mobile": {
                    return {
                        rounded: false,
                        elevation: 0,
                    };
                }
            }
        },
    },
    mounted() {
        this.getUser();
    },
    methods: {
        ...mapActions(["getUser"]),
        certificate() {
            if (this.user?.ci) return alert("본인인증에 등록된 회원입니다");

            this.$refs.kcpCert.$off();
            this.$refs.kcpCert.$on("input", async ({ _cert }) => {
                let result = await api.v1.me.certificate({ _cert });
                await this.getUser();
                if (result.success) {
                    alert("본인인증이 등록되었습니다");
                }
            });
            this.$refs.kcpCert.open();
        },
    },
};
</script>

<style lang="scss" scoped>
.cash-btn::before {
    display: none;
}
</style>
